import type { LitswRegistrationConfig } from '@bcf2-v1-ui-shared/service-worker/litsw-registration.types';

export const casinoMobileOptiLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/casino/mobile-sw.js',
  enabled: true,
  withLangQuery: true
};

export const casinoMobileLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/casino/mobile-sw.js',
  enabled: true
};

export const casinoDesktopLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/casino/desktop-sw.js',
  enabled: true
};

export const casinoDesktopOptiLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/casino/desktop-sw.js',
  enabled: true,
  withLangQuery: true
};

export const mobileLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/mobile-sw.js',
  enabled: true
};

export const desktopLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/desktop-sw.js',
  enabled: true
};

export const sportsMobileOptiLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/sports/mobile-sw.js',
  enabled: true,
  withLangQuery: true
};

export const sportsMobileLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/sports/mobile-sw.js',
  enabled: true
};

export const sportsDesktopOptiLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/sports/desktop-sw.js',
  enabled: true,
  withLangQuery: true
};

export const sportsDesktopLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/sports/desktop-sw.js',
  enabled: true
};

export const sportsbookMobileOptiLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/sportsbook/mobile-sw.js',
  enabled: true,
  withLangQuery: true
};

export const sportsbookDesktopOptiLitswRegistrationConfig: LitswRegistrationConfig = {
  script: '/sportsbook/desktop-sw.js',
  enabled: true,
  withLangQuery: true
};
